<template>
	<view class="box">
		<view class="data">
			<view class="hezi">
				<view class="hezi-a">
					<text>账户余额(元)</text>
					<u-icon name="eye" color="#ffffff" size="16"></u-icon>
				</view>
				<view class="hezi-b">
					<view class="hezi-b-price">
						<text>12,000</text>
						<text>.00</text>
					</view>
					<view class="hezi-b-btn">提现</view>
				</view>
				<view class="hezi-c">
					<view class="hezi-c-item">
						<text class="hezi-c-item-title">待结算(元)</text>
						<view class="hezi-c-item-price">
							<text>560</text>
							<text>.00</text>
						</view>
					</view>
					<view class="hezi-c-item">
						<text class="hezi-c-item-title">待结算(元)</text>
						<view class="hezi-c-item-price">
							<text>560</text>
							<text>.00</text>
						</view>
					</view>
				</view>
			</view>
			<view class="tx">
				提现中：¥400.00
			</view>
		</view>
		<view class="sele">
			<text>全部</text>
			<u-icon name="arrow-down" color="#222222" size="16"></u-icon>
		</view>
		<view class="box-list">
			<view class="item">
				<view class="item-date">
					<view class="item-date-top">
						<text>2025年11月</text>
						<image src="/static/icon/ic_open@2x.png" mode="widthFix"></image>
					</view>
					<view class="item-date-bottom">
						<text>销售额：¥20000.00</text>
						<text>结算利润：¥2000.00</text>
					</view>
				</view>
				<view class="item-list">
					<view class="item-list-item">
						<view class="image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="info">
							<view class="info-a">
								<view class="info-a-label">自提单</view>
								<view class="info-a-price">
									<text>4000</text>
									<text>.00</text>
								</view>
							</view>
							<view class="info-b">
								<text>李婷平-1815****5556</text>
								<text>利润¥400.00</text>
							</view>
							<view class="info-b">
								<text>订单号：713792839842</text>
								<text>11月21日 17:32:21</text>
							</view>
						</view>
					</view>
					<view class="item-list-item">
						<view class="image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="info">
							<view class="info-a">
								<view class="info-a-label">配送订单</view>
								<view class="info-a-price">
									<text>4000</text>
									<text>.00</text>
								</view>
							</view>
							<view class="info-b">
								<text>李婷平-1815****5556</text>
								<text>利润¥400.00</text>
							</view>
							<view class="info-b">
								<text>订单号：713792839842</text>
								<text>11月21日 17:32:21</text>
							</view>
						</view>
					</view>
					<view class="item-list-item">
						<view class="image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="info">
							<view class="info-a">
								<view class="info-a-label">配送订单</view>
								<view class="info-a-price">
									<text>4000</text>
									<text>.00</text>
								</view>
							</view>
							<view class="info-b">
								<text>李婷平-1815****5556</text>
								<text style="color: #E4001D;">已退款 -¥7800.00</text>
							</view>
							<view class="info-b">
								<text>订单号：713792839842</text>
								<text>11月21日 17:32:21</text>
							</view>
						</view>
					</view>
				</view>
			</view>
		</view>
		<!-- 筛选 -->
		<u-popup :show="show" mode="bottom" :safeAreaInsetBottom="false" round="15" :closeable="true" @close="show = false">
			<view class="sear">
				<view class="sear-title">筛选</view>
				<view class="sear-item">
					<view class="sear-item-label">收支类型</view>
					<view class="sear-item-list">
						<view class="sear-item-list-item active">全部</view>
						<view class="sear-item-list-item">收入</view>
						<view class="sear-item-list-item">支出</view>
						<view style="width: 216rpx; height: 0;"></view>
					</view>
				</view>
				<view class="sear-item">
					<view class="sear-item-label">交易类型</view>
					<view class="sear-item-list">
						<view class="sear-item-list-item active">全部</view>
						<view class="sear-item-list-item">订单结算</view>
						<view class="sear-item-list-item">提现</view>
						<view class="sear-item-list-item">订单结算退回</view>
						<view class="sear-item-list-item">提现退回</view>
						<view style="width: 216rpx; height: 0;"></view>
					</view>
				</view>
				<view class="sear-footer">
					<view class="sear-footer-btn1">重置</view>
					<view class="sear-footer-btn2">确认</view>
				</view>
			</view>
		</u-popup>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				show: false
			};
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.sear {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			.sear-title {
				width: 100%;
				text-align: center;
				font-weight: 500;
				font-size: 32rpx;
				color: #111111;
			}
			.sear-item {
				width: 100%;
				display: flex;
				flex-direction: column;
				margin-top: 48rpx;
				.sear-item-label {
					font-weight: 500;
					font-size: 32rpx;
					color: #111111;
				}
				.sear-item-list {
					margin-top: 30rpx;
					display: flex;
					align-items: center;
					justify-content: space-between;
					flex-wrap: wrap;
					.active {
						background: rgba(0,64,150,0.1) !important;
						color: #004096 !important;
					}
					.sear-item-list-item {
						width: 216rpx;
						height: 72rpx;
						line-height: 72rpx;
						text-align: center;
						background: #F7F7F7;
						border-radius: 8rpx;
						font-weight: 400;
						font-size: 28rpx;
						color: #333333;
						margin-bottom: 20rpx;
					}
				}
			}
			.sear-footer {
				width: 100%;
				height: 88rpx;
				margin-top: 80rpx;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.sear-footer-btn1 {
					width: 334rpx;
					height: 88rpx;
					line-height: 88rpx;
					text-align: center;
					background: #E5E5E5;
					border-radius: 44rpx;
					font-weight: 500;
					font-size: 32rpx;
					color: #333333;
				}
				.sear-footer-btn2 {
					width: 334rpx;
					height: 88rpx;
					line-height: 88rpx;
					text-align: center;
					background: #004096;
					border-radius: 44rpx;
					font-weight: 500;
					font-size: 32rpx;
					color: #FFFFFF;
				}
			}
		}
		.box-list {
			width: 100%;
			display: flex;
			flex-direction: column;
			.item {
				width: 100%;
				.item-date {
					width: 100%;
					display: flex;
					flex-direction: column;
					padding: 30rpx;
					box-sizing: border-box;
					.item-date-top {
						width: 100%;
						display: flex;
						align-items: center;
						image {
							width: 26rpx;
							height: 26rpx;
							margin-left: 12rpx;
						}
						text {
							font-weight: 600;
							font-size: 32rpx;
							color: #222222;
						}
					}
					.item-date-bottom {
						width: 100%;
						display: flex;
						align-items: center;
						margin-top: 20rpx;
						text {
							font-weight: 400;
							font-size: 26rpx;
							color: #777777;
							&:nth-child(2) {
								margin-left: 62rpx;
							}
						}
					}
				}
				.item-list {
					width: 100%;
					display: flex;
					flex-direction: column;
					padding: 0 30rpx;
					box-sizing: border-box;
					background-color: #ffffff;
					.item-list-item {
						width: 100%;
						padding: 30rpx 0;
						box-sizing: border-box;
						border-bottom: 1rpx solid #E5E5E5;
						display: flex;
						align-items: flex-start;
						justify-content: center;
						.image {
							flex-shrink: 0;
							width: 72rpx;
							height: 72rpx;
							border-radius: 50%;
							overflow: hidden;
							margin-right: 20rpx;
							image {
								width: 100%;
							}
						}
						.info {
							flex: 1;
							display: flex;
							flex-direction: column;
							.info-a {
								width: 100%;
								display: flex;
								align-items: center;
								justify-content: space-between;
								.info-a-label {
									font-weight: 500;
									font-size: 30rpx;
									color: #222222;
								}
								.info-a-price {
									display: flex;
									align-items: baseline;
									text {
										&:nth-child(1) {
											font-weight: 600;
											font-size: 32rpx;
											color: #222222;
											&::before {
												content: "+";
												font-weight: 600;
												font-size: 32rpx;
												color: #222222;
											}
										}
										&:nth-child(2) {
											font-weight: 600;
											font-size: 24rpx;
											color: #222222;
										}
									}
								}
							}
							.info-b {
								width: 100%;
								display: flex;
								align-items: center;
								justify-content: space-between;
								margin-top: 12rpx;
								text {
									font-weight: 400;
									font-size: 24rpx;
									color: #999999;
								}
							}
						}
					}
				}
			}
		}
		.sele {
			width: 200rpx;
			height: 64rpx;
			padding: 0 24rpx;
			box-sizing: border-box;
			background: #FFFFFF;
			border-radius: 32rpx;
			border: 1rpx solid #EEEEEE;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-left: 30rpx;
			text {
				font-weight: 400;
				font-size: 26rpx;
				color: #333333;
			}
		}
		.data {
			width: 100%;
			padding: 20rpx 30rpx;
			box-sizing: border-box;
			.hezi {
				width: 100%;
				height: 304rpx;
				padding: 30rpx;
				box-sizing: border-box;
				background: #004096;
				border-radius: 16rpx;
				.hezi-a {
					width: 100%;
					display: flex;
					align-items: center;
					text {
						font-weight: 400;
						font-size: 24rpx;
						color: rgba(255,255,255,0.7);
						margin-right: 20rpx;
					}
				}
				.hezi-b {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-top: 14rpx;
					.hezi-b-price {
						display: flex;
						align-items: baseline;
						text {
							&:nth-child(1) {
								font-weight: 600;
								font-size: 44rpx;
								color: #FFFFFF;
							}
							&:nth-child(2) {
								font-weight: 600;
								font-size: 26rpx;
								color: #FFFFFF;
							}
						}
					}
					.hezi-b-btn {
						width: 100rpx;
						height: 52rpx;
						line-height: 52rpx;
						text-align: center;
						background: #FFFFFF;
						border-radius: 26rpx;
						font-weight: 500;
						font-size: 26rpx;
						color: #004096;
					}
				}
				.hezi-c {
					width: 100%;
					height: 138rpx;
					margin-top: 24rpx;
					display: flex;
					align-items: center;
					border-top: 1rpx solid rgba(255,255,255,0.09);
					.hezi-c-item {
						flex: 1;
						height: 100%;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						&:first-child {
							border-right: 1rpx solid rgba(255,255,255,0.09);
						}
						.hezi-c-item-title {
							font-weight: 400;
							font-size: 24rpx;
							color: rgba(255,255,255,0.7);
						}
						.hezi-c-item-price {
							display: flex;
							align-items: baseline;
							margin-top: 8rpx;
							text {
								&:nth-child(1) {
									font-weight: 600;
									font-size: 30rpx;
									color: #FFFFFF;
								}
								&:nth-child(2) {
									font-weight: 600;
									font-size: 26rpx;
									color: #FFFFFF;
								}
							}
						}
					}
				}
			}
			.tx {
				width: 100%;
				height: 104rpx;
				background: rgba(0,64,150,0.12);
				border-radius: 16rpx;
				position: relative;
				top: -20rpx;
				font-weight: 400;
				font-size: 26rpx;
				color: #004096;
				padding: 40rpx 30rpx 0 30rpx;
				box-sizing: border-box;
			}
		}
	}
</style>